import { pluginMetadata } from "../core/plugins/metadata";
import { Option } from "../core/options/option";
import { OptionGroup } from "../core/options/option-group";
import { parameterOptions, toolsOptions } from "./parameters";

export const globalOptions: OptionGroup[] = [
    parameterOptions,
    toolsOptions,
    // All other options have been removed and replaced with hardcoded values
];

// Quick settings removed
